import useMutation from "src/hooks/useMutation";

function useWarehouseTransferCreate() {
  return useMutation({
    path: `/api/v1/warehouse-transfers`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/warehouse-transfers`,
      shouldRevalidate: true,
    },
  });
}

export default useWarehouseTransferCreate;
